import styled from 'styled-components';

export const FooterArea = styled.div`
    display:flex;
    justify-content:center;
    flex-direction:column;
    align-items:center;
    background-color:#FFF;
    height:100px;
    border:1px solid #CCC;
    border-radius:5px;
    margin:10px 0px;

    .container{
        margin-Top:5px;
        color:#000;
        font-size:12px;
        text-align:center;

        img{
            margin-Top:0px;
            height:70px;
        }
    }
`;